<template>
 <div>
    <el-dialog :append-to-body='true' :title="title" :visible.sync="visible" :before-close="close" width="75%">
      <base-table
        :columns="tableLabels"
        selectType=""
        :table-data="tableData"
      >
      <template slot="status" slot-scope="scope">
        {{scope.row.status_text}}
        <el-tag v-if="scope.row.urgent" type="danger" size="small">加急</el-tag>
        <el-tag v-if="scope.row.overDue" type="warning" size="small">逾期</el-tag>
      </template>
      </base-table>
    </el-dialog>
 </div>
</template>

<script>
  
import { tableLabels } from 'cps/production-task/pt-production-task-list/options'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    // lotOperateList,
    // lotOperateListBoard
  },
  watch: {
    dialogVisible (val) {
      this.visible = val
    }
  },
  data () {
    return {
      tableLabels:tableLabels.slice(0, tableLabels.length-1),
      visible: this.dialogVisible,
      title: '已勾选数据'
    }
  },
  methods: {
    close () {
      this.$emit('updateVisible', false)
    },
    goDetail (id) {
      this.$router.push(`/trust-deed-detail/${id}`)
    }
  }
}
</script>

<style lang="less">

</style>
